import {ACTIONS} from "../reducers/dropdownMenuReducer";

export function openDropdownMenu() {
  return {type: ACTIONS.OPEN_DROPDOWN_MENU};
}

export function closeDropdownMenu() {
  return {type: ACTIONS.CLOSE_DROPDOWN_MENU};
}
